<!-- breadcrumb item -->
<div class="row">
  <div class="col-12">
    <div class="page-title-box-meridian">
      <ol class="breadcrumb-meridian">
        <ng-container *ngFor="let item of breadcrumbItems; let last = last">
          <li *ngIf="!item.active"><a class="enablePointer" (click)="route(item.href)">{{ item.label }}</a></li>
          <li *ngIf="item.active" class="active">{{ item.label }}</li>
          <li *ngIf="!last" class="breadcrumb-meridian__sep">/</li>
        </ng-container>
      </ol>
      <h1 class="page-title-heading">{{ title }}</h1>
    </div>
  </div>
</div>
